"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var version = require('../../package.json').version; //eslint-disable-line
exports.version = version;
exports.authResponseProperty = 'RCAuthorizationResponse';
//# sourceMappingURL=Constants.js.map